<p-progressSpinner *ngIf="!foreignOutflowMetric.initialized" [style]="{width: '50px', height: '50px'}" fxFlex="1 1 auto" class="spinner"  animationDuration="2s"></p-progressSpinner>
<div *ngIf="foreignOutflowMetric.initialized" fxFlex="auto" fxLayout="row" class="trend-metric corner-triangle" [ngStyle]="{'background-color': lightMetricColor(foreignOutflowMetric)}">
    <div fxFlex="1 1 10%">
    </div>
    <span fxFlex="1 1 20%" class="liquitics-h3"></span>
    <span fxFlex="1 1 35%" class="trend-metric-value liquitics-h1">{{foreignOutflowMetric.netflowShort }}</span>
    <!-- <span fxFlex="1 1 35%" class="trend-metric-value liquitics-h1">{{foreignOutflowMetric.netflow | currencyrounding:0:foreignOutflowMetric.basecurrency:'symbol-narrow'}}</span> -->
    <span fxFlex="1 1 20%" class="liquitics-h3"></span>
    <div fxFlex="1 1 10%" class="trend-metric-delta">
    </div>
    <span fxFlex="1 1 5%" class="fa fa-level-down jump-to-history" fxFlexAlign="end" (click)="onDrillDown()"></span>
</div>